module.exports = __webpack_public_path__ + "img/MUSLIMNESIA.6ae574a5.png";